var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-widget-extension gl-rounded-b-lg gl-border-t-0",attrs:{"data-testid":"approvals-footer"}},[_c('approvals-list',{attrs:{"code-coverage-check-help-page-path":_vm.codeCoverageCheckHelpPagePath,"eligible-approvers-docs-path":_vm.eligibleApproversDocsPath,"project-path":_vm.projectPath,"iid":_vm.iid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }